import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
// import { useHistory } from 'react-router-dom'; // version 5.2.0
import _ from "underscore";
// XLSX
import * as XLSX from 'xlsx/xlsx.mjs';
// Services
import GroupService from "../services/groups.service";
import PlantsService from "../services/plants.service";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";

// Components
import SummaryModal from './SummaryModal';
import SearchForm from "./SearchForm";
import PhenotypeModal from "./PhenotypeModal";
import PhenotypeTable from "./PhenotypeTable";
import BarcodeScan from "./BarcodeScan";
import PlantsGroups from "./PlantsGroups";
import NotesModal from "./NotesModal";
import ClonesModal from "./ClonesModal";
import SearchPhenotype from "./SearchPhenotype";

// Data Table 
import DataTable from "react-data-table-component";
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Button from "react-bootstrap/Button";
import styled from 'styled-components';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import SettingsIcon from '@mui/icons-material/Settings';
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import InfoIcon from '@mui/icons-material/Info';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import StorageIcon from '@mui/icons-material/Storage';

import almondImage from '../img/almond.png';

// Socket.io
import socketIOClient from 'socket.io-client';
import socketUrl from '../common/GetSocket';
import { Redirect } from "react-router-dom";
const ENDPOINT = socketUrl();
console.log("endpoint: ", ENDPOINT );

const GREEN = {
    800: "#2e7d32",
    700: "#388e3c",
    600: "#43a047",
    500: "#4caf50",
    400: "#66bb6a",
    50: "#e8f5e9",
};
const GREY = { 100: "#f5f5f5", 200: "#eeeeee", 300: "#e0e0e0", 600: "#757575" };

const tableCustomStyles = {
    headRow: { style: { backgroundColor: GREY[100], borderBottom: `2px solid ${GREEN[500]}`, fontWeight: 600, fontSize: "0.8rem", color: "#333", textTransform: "uppercase", letterSpacing: "0.03em" } },
    headCells: { style: { paddingLeft: "12px", paddingRight: "12px" } },
    rows: { style: { fontSize: "0.85rem", color: "#333", minHeight: "48px", "&:hover": { backgroundColor: GREEN[50] } }, stripedStyle: { backgroundColor: GREY[100] } },
    cells: { style: { paddingLeft: "12px", paddingRight: "12px" } },
    pagination: { style: { borderTop: `1px solid ${GREY[300]}`, fontSize: "0.8rem" } },
};

const TextFieldSearch = styled.input`
    height: 36px;
    width: 220px;
    border-radius: 6px 0 0 6px;
    border: 1px solid ${GREY[300]};
    padding: 0 12px;
    font-size: 0.85rem;
    outline: none;
    transition: border-color 0.2s ease;
    &:focus { border-color: ${GREEN[500]}; }
    &:hover { border-color: ${GREEN[400]}; }
`;
const ClearButton = styled(Button)`
    border-radius: 0 6px 6px 0 !important;
    height: 36px;
    min-width: 36px !important;
    padding: 0 !important;
    background-color: ${GREY[200]} !important;
    color: ${GREY[600]} !important;
    border: 1px solid ${GREY[300]} !important;
    border-left: none !important;
    font-weight: 600 !important;
    &:hover { background-color: ${GREY[300]} !important; }
`;
const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
        <TextFieldSearch
            id="search"
            type="text"
            placeholder="Filter by Company Code"
            aria-label="Search Input"
            value={filterText}
            onChange={onFilter}
        />
        <ClearButton type="button" onClick={onClear}>
            X
        </ClearButton>
    </>
);
const sortIcon = <ArrowDownward />;

const PlantSearch = () => {
    let [searchResults, setSearchResults] = useState([]);
    let [command, setCommand] = useState("");
    let [spinner, setSpinner] = useState(false);
    let [errorMessage, setErrorMessage] = useState("");
    let [loadingMessage, setLoadingMessage] = useState("");
    let [plantSummary, setPlantSummary] = useState([]);
    let [clones, setClones ] = useState([]);
    let [showModal, setShowModal] = useState(false);
    let [showClonesModal, setShowClonesModal] = useState(false);
    let [showPhenotypeModal, setShowPhenotypeModal] = useState(false);
    let [showNotesModal, setShowNotesModal] = useState(false);
    let [showCommand, setShowCommand] = useState(false);
    let [currentPlant, setCurrentPlant ] = useState({});
    let [selection, setSelection] = useState('');
    let [phenotypes, setPhenotypes] = useState([]);
    let [phenotypeResults, setPhenotypeResults] = useState([]);
    let [plantPhenotypes, setPlantPhenotypes] = useState([]);
    let [plantDescriptors, setPlantDescriptors] = useState([]);
    let [showPhenotypes, setShowPhenotypes ] = useState(false);
    let [hideLocation, setHideLocation] = useState(true);
    let [showPlantsGroups, setShowPlantsGroups ] = useState( false );
    let [maternalCrosses, setMaternalCrosses ] = useState([]);
    let [paternalCrosses, setPaternalCrosses ] = useState([]);
    const [redirect, doRedirect] = useState(false)

    let clearResults = () => {
        setSearchResults([]);
        setCommand("");
    }

    let handleGetInfo = (state) => {
        setSpinner(true)
        console.log('clicked: ', state);
        var obj = {
            code: state['Verinomics Code'],
            company: "Burchell"
        }
        console.log("obj: ", obj);
        PlantsService.getPlantSummary(obj).then(
            (response) => {
                console.log("plant response: ", response);

                var arr = [];
                _.each(Object.keys(response.result), function (value) {
                    if (typeof response.result[value] == "string") {
                        var obj = {
                            key: value,
                            data: response.result[value]
                        }
                        arr.push(obj);
                    }
                });
                // console.log("arr: ", arr);
                setPaternalCrosses( response.result.PaternalCrosses );
                setMaternalCrosses( response.result.MaternalCrosses );
                setPlantPhenotypes( response.result.Phenotypes );
                setPlantDescriptors( response.result.Descriptors );
                setPlantSummary(arr);
                setShowModal(true);
                setSpinner(false)
            },
            (error) => {
                console.log("error: ", error);
                setSpinner(false)
            }
        );

    };

    let handleAddNotes = (state) => {
        setSpinner(true)
        console.log('clicked: ', state);
        var obj = {
            code: state['Verinomics Code'],
            company: "Burchell"
        }
        console.log("obj: ", obj);
        setCurrentPlant( state );
        setShowNotesModal( true );
        setSpinner(false);
    }

    let handleFindClones = ( state ) => {
        setSpinner(true);
        console.log("state: ", state );
        var obj = {
            idPlant: state.idPlant,
            company: "Burchell"
        };
        // Send Request
        PlantsService.findClones( obj ).then(
            (response) => {
                console.log("clones response: ", response );
            },
            (error) => {
                console.log("error: ", error );
                setSpinner(false);
            }
        )
    }

    let clickShowCommand = () => {
        console.log("clicked..");
        setShowCommand(!showCommand);
    }

    /** Dropdown */
    let handleChange = (event) => {
        // console.log("event: ", event.target.value );
        setSelection( event.target.value ) 
        switch (event.target.value) {
            case 'phenotypes':
                console.log("phenos");
                getAvailablePhenotypes();
                setTimeout(function() {
                    setSelection("");
                },500);
                break;
            case 'download':
                console.log("download");
                downloadResults();
                setTimeout(function() {
                    setSelection("");
                },500);
                break;
                case 'locations':
                console.log("locs");
                findLocations();
                setTimeout(function() {
                    setSelection("");
                },500);
                break;
            case 'add':
                console.log("add");
                setShowPlantsGroups( true );
                setTimeout(function() {
                    setSelection("");
                },500);
                break;
            case 'clear':
                console.log("clear");
                clearResults();
                setTimeout(function() {
                    setSelection("");
                },500);
                break;
            default:
                console.log("something went wrong..");
        }

    };

    let getAvailablePhenotypes = () => {
        console.log("get phenos..");
        setSpinner(true);
        var ids = _.pluck(searchResults, 'idPlant');
        var obj = {
            idCompany: 1,
            company: "Burchell",
            ids: ids.join(",")
        };
        console.log("obj: ", obj);
        // Send Request
        GroupService.getAvailablePhenotypes(obj).then(
            (response) => {
                // Success
                console.log("pheno response: ", response);
                console.log("found phenotypes...");

                var phenos = [];
                _.each(response.result.Phenotypes, function (value) {
                    var obj = { value: value }
                    phenos.push( obj );
                });
                phenos.push({value:"Check All"});
                setPhenotypes(phenos);
                setShowPhenotypeModal(true);
                setSpinner(false);
            },
            (error) => {
                // Error
                console.log("something went wrong..");
                setSpinner(false);
            }
        )
    }

    let downloadResults = () => {
        setSpinner(true)
        console.log("download search results.");

        let results = [];
        _.each( filteredItems, function(value) {
            // console.log("value: ", value );
            var obj = {
                idPlant: value.idPlant,
                PlantCode: value.PlantCode,
                AlternatePlantID: value.externalID,
                'Verinomics Code': value.PlantCode,
                'Company Code': value.externalID
            };
            results.push( obj );
        });
        console.log("search results: ", results );

        /* generate a worksheet */
        var ws = XLSX.utils.json_to_sheet( results );

        /* add to workbook */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet( wb, ws, "Verinomics");

        /* write workbook and force a download */
        XLSX.writeFile( wb, "SearchResults.xlsx");
        // Loading
        setTimeout(function() {
            setSpinner(false)
        },500);
    }

    let findLocations = () => {
        setSpinner(true);
        var ids = _.pluck( searchResults, 'idPlant');
        var obj = {
            ids: ids.join(","),
            idCompany: 1,
            company: "Burchell"
        };
        console.log("obj: ", obj );
        PlantsService.findLocations( obj ).then(
            ( response ) => {
                console.log("loc response: ", response );

                var obj = {
                    name: 'Location',
                    selector: row => row.Location,
                    sortable: true,
                };

                columns.push( obj );
                console.log('cols: ', columns );

                var results = [];
                _.each(response.result, function (value) {
                    // console.log("value: ", value );
                    var obj = {
                        idPlant: value.idPlant,
                        PlantCode: value.PlantCode,
                        AlternatePlantID: value.AlternatePlantID,
                        'Verinomics Code': value.PlantCode,
                        'Company Code': value.AlternatePlantID,
                        CrossCode: value.CrossCode,
                        AlternateCrossID: value.AlternateCrossID,
                        Location: value.Location,
                    };
                    results.push(obj);
                });

                setSearchResults( results );
                setSpinner( false );
                
                setHideLocation( !hideLocation );

            },
            ( error ) => {
                console.log("error: ", error );
                setSpinner( false );
            }
        )


    }

    const columns = useMemo(
        () => [
            {
                name: 'Company Code',
                selector: row => row['Company Code'],
                sortable: true,
                grow: 2,
                reorder: true,
            },
            {
                name: 'Verinomics Code',
                selector: row => row['Verinomics Code'],
                sortable: true,
                grow: 2,
                reorder: true,
            },
            {
                name: 'Cross Code',
                selector: row => row.CrossCode,
                sortable: true,
                grow: 2,
                reorder: true,
            },
            {
                name: 'AlternateCrossID',
                selector: row => row.AlternateCrossID,
                sortable: true,
                grow: 2,
                reorder: true,
            },
            {
                name: 'Location',
                selector: row => row.Location,
                sortable: true,
                grow: 2,
                omit: hideLocation,
            },
            {
                name: "More Info",
                cell: (row) => <button style={{ margin: "4px", padding: "6px 10px", borderRadius: "6px", border: "none", backgroundColor: GREEN[500], color: "#fff", cursor: "pointer", display: "inline-flex", alignItems: "center", transition: "background-color 0.2s" }} onMouseOver={e => e.currentTarget.style.backgroundColor = GREEN[700]} onMouseOut={e => e.currentTarget.style.backgroundColor = GREEN[500]} onClick={() => handleGetInfo(row)} id={row.ID}> <InfoIcon fontSize="small" /> </button>,
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
            },
            {
                name: "Add Notes",
                cell: (row) => <button style={{ margin: "4px", padding: "6px 10px", borderRadius: "6px", border: `1px solid ${GREEN[500]}`, backgroundColor: "#fff", color: GREEN[700], cursor: "pointer", display: "inline-flex", alignItems: "center", transition: "all 0.2s" }} onMouseOver={e => { e.currentTarget.style.backgroundColor = GREEN[50]; }} onMouseOut={e => { e.currentTarget.style.backgroundColor = "#fff"; }} onClick={() => handleAddNotes(row)} id={row.ID}> <SpeakerNotesIcon fontSize="small" /> </button>,
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
            },
            {
                name: "Find Clones",
                cell: (row) => <button style={{ margin: "4px", padding: "6px 10px", borderRadius: "6px", border: "none", backgroundColor: GREY[200], color: GREY[600], cursor: "pointer", display: "inline-flex", alignItems: "center", transition: "background-color 0.2s" }} onMouseOver={e => e.currentTarget.style.backgroundColor = GREY[300]} onMouseOut={e => e.currentTarget.style.backgroundColor = GREY[200]} onClick={() => handleFindClones(row)} id={row.ID}> <SearchIcon fontSize="small" /> </button>,
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
            },
        ],
        [hideLocation],
    );

    // Filter
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const filteredItems = searchResults.filter(
        item => item['Company Code'] && item['Company Code'].toLowerCase().includes(filterText.toLowerCase()),
    );
    const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
        );
    }, [filterText, resetPaginationToggle]);

    const { user: currentUser } = useSelector((state) => state.auth);
    // console.log("current user: ", currentUser );

    useEffect(() => {
        const socket = socketIOClient(ENDPOINT);
        console.log("socket: ", socket);
        
        /** Search Results */
        socket.on("pedigree-search", response => {
            console.log("socket.io results: ", response);
            if( currentUser.id === response.user.id ) {
                if (response.status === 0) {
                    setLoadingMessage("");
                    var results = [];
                    _.each(response.result, function (value) {
                        // console.log("value: ", value );
                        var obj = {
                            idPlant: value.idPlant,
                            PlantCode: value.PlantCode,
                            AlternatePlantID: value.AlternatePlantID,
                            'Verinomics Code': value.PlantCode,
                            'Company Code': value.AlternatePlantID,
                            CrossCode: value.CrossCode,
                            AlternateCrossID: value.AlternateCrossID
                        };
                        results.push(obj);
                    });
    
                    setSearchResults(results);
                    setSpinner(false);
                    setCommand(response.cmd);
                } else if (response.status === 2) {
                    console.warn("no plants...");
                    // No Plants Found 
                    setLoadingMessage("");
                    setErrorMessage("No plants found in the database.");
                    setTimeout(function () {
                        setErrorMessage("");
                        setSpinner(false)
                    }, 3000);
                } else {
                   setLoadingMessage("");
                   console.warn("something went wrong");
                   setSpinner(false)
                }
            } 
        });

        socket.on("clones", response => {
            // console.log("socket.io results: ", response);
            if( currentUser.id === response.user.id ) {
                setClones( response.result );
                setShowClonesModal( true );
                setSpinner(false);
            }
        });

        UserService.getUserBoard().then(
            (response) => {
                // console.log("user response: ", response);
            },
            (error) => {
                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log("error: ", _content);
                doRedirect( true );
                
                if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                    EventBus.dispatch("logout");
                }
            }
        );

    }, [currentUser]);

    return (
        <>
        <div className="container" style={{ paddingTop: "24px", paddingBottom: "40px" }}>
            <div style={{
                background: "#fff",
                borderRadius: "16px",
                padding: "40px 32px",
                marginBottom: "24px",
                border: "1px solid #f5f5f5",
                boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
            }}>
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "120px",
                    height: "4px",
                    borderRadius: "0 0 4px 4px",
                    background: `linear-gradient(90deg, ${GREEN[500]}, ${GREEN[400]})`,
                }} />
                <h3 style={{ margin: 0, fontWeight: 800, fontSize: "1.5rem", color: "#1a2e1a", letterSpacing: "-0.02em" }}>Plant Search</h3>
                <div style={{
                    width: "48px",
                    height: "3px",
                    borderRadius: "4px",
                    background: `linear-gradient(90deg, ${GREEN[500]}, ${GREEN[400]})`,
                    margin: "12px auto",
                }} />
                <p style={{ margin: 0, color: "#546e7a", fontSize: "0.95rem", lineHeight: 1.7 }}>Search our database for plants and phenotypes.</p>
            </div>
            <div className="row">
                { redirect && <Redirect to="/"/> }
                {spinner &&
                    <div className="almond-spinner">
                        <img src={almondImage} alt="Almond Spinner" />
                    </div>
                }
                {filteredItems.length !== 0 ?
                    (
                        <div className="col-md-12">
                            <div style={{ backgroundColor: "#fff", borderRadius: "10px", boxShadow: "0 1px 8px rgba(0,0,0,0.06)", border: `1px solid ${GREY[300]}`, overflow: "hidden" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", backgroundColor: GREY[100], borderBottom: `2px solid ${GREEN[500]}` }}>
                                    <span style={{ fontWeight: 600, fontSize: "1rem", color: "#333" }}>
                                        Search Results &mdash; <span style={{ color: GREEN[700] }}>{searchResults.length}</span> Plants
                                    </span>
                                    <Box sx={{ minWidth: 180 }}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel id="Options-Label" sx={{ color: GREY[600], "&.Mui-focused": { color: GREEN[600] } }}> <SettingsIcon fontSize="small" sx={{ mr: 0.5, verticalAlign: "middle" }} /> Options</InputLabel>
                                            <Select
                                                labelId="Options-Label"
                                                id="demo-simple-select"
                                                value={selection}
                                                label=""
                                                onChange={handleChange}
                                                sx={{
                                                    borderRadius: "8px",
                                                    backgroundColor: "#fff",
                                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: GREY[300] },
                                                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: GREEN[400] },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: GREEN[500] },
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em style={{ color: GREY[600] }}>Select Option</em>
                                                </MenuItem>
                                                <MenuItem value={"phenotypes"}> <SearchIcon sx={{ mr: 1, color: GREEN[600] }} fontSize="small" /> Get Available Phenotypes</MenuItem>
                                                <MenuItem value={"download"}> <DownloadIcon sx={{ mr: 1, color: GREEN[600] }} fontSize="small" /> Download Results</MenuItem>
                                                <MenuItem value={"locations"}> <SearchIcon sx={{ mr: 1, color: GREEN[600] }} fontSize="small" /> Find Locations</MenuItem>
                                                <MenuItem value={"add"}> <AddCircleIcon sx={{ mr: 1, color: GREEN[600] }} fontSize="small" /> Add Plants to a Group</MenuItem>
                                                <MenuItem value={"clear"}> <HighlightOffIcon sx={{ mr: 1, color: "#d32f2f" }} fontSize="small" /> Clear Search Results</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </div>
                                <div style={{ padding: "16px 20px" }}>
                                    {searchResults &&
                                        <DataTable
                                            sortIcon={sortIcon}
                                            columns={columns}
                                            data={filteredItems}
                                            customStyles={tableCustomStyles}
                                            onColumnOrderChange={cols => console.log(cols)}
                                            subHeader
                                            subHeaderComponent={subHeaderComponentMemo}
                                            highlightOnHover
                                            pagination
                                            responsive
                                            striped
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="col-md-12">
                                {errorMessage !== "" && (
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "12px 18px", borderRadius: "8px", backgroundColor: "#fdecea", border: "1px solid #f5c6cb", color: "#611a15", marginBottom: "16px", fontSize: "0.9rem" }} role="alert">
                                        <StorageIcon fontSize="small" /> <b>Server Response:</b> {errorMessage}
                                    </div>
                                )}

                                {loadingMessage !== "" && (
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "12px 18px", borderRadius: "8px", backgroundColor: GREEN[50], border: `1px solid ${GREEN[400]}`, color: GREEN[800], marginBottom: "16px", fontSize: "0.9rem" }} role="alert">
                                        <RotateRightIcon fontSize="small" /> <b>Loading:</b> {loadingMessage}
                                    </div>
                                )}
                            </div>
                            <div className="col-md-6">
                                <SearchForm setSpinner={setSpinner} />

                                <BarcodeScan 
                                    setSpinner={setSpinner}
                                    setCommand={setCommand}
                                    setSearchResults={setSearchResults} 
                                    setErrorMessage={setErrorMessage} 
                                />
                            </div>
                            <div className="col-md-6">
                                <SearchPhenotype 
                                    setLoading={setSpinner}
                                    setSearchResults={setSearchResults} 
                                />
                            </div>
                        </>
                    )
                }
            </div>
            <SummaryModal
                show={showModal}
                setShow={setShowModal}
                setSpinner={setSpinner}
                plantSummary={plantSummary}
                plantPhenotypes={plantPhenotypes}
                plantDescriptors={plantDescriptors}
                maternalCrosses={maternalCrosses}
                paternalCrosses={paternalCrosses}
            />
            <PhenotypeModal
                show={showPhenotypeModal}
                setShow={setShowPhenotypeModal}
                setSpinner={setSpinner}
                phenotypes={phenotypes}
                searchResults={searchResults}
                setSelection={setSelection}
                setShowPhenotypes={setShowPhenotypes}
                setPhenotypeResults={setPhenotypeResults}

            />
            <PhenotypeTable
                show={showPhenotypes}
                setShow={setShowPhenotypes}
                setSpinner={setSpinner}
                setShowModal={setShowPhenotypeModal}
                phenotypeResults={phenotypeResults}
                setPlantPhenotypes={setPlantPhenotypes}
                setPlantDescriptors={setPlantDescriptors}
                setPlantSummary={setPlantSummary}
                setShowSummaryModal={setShowModal}
            />
            <PlantsGroups 
                show={showPlantsGroups}
                setShow={setShowPlantsGroups}
                searchResults={ searchResults }
            />
            <NotesModal 
                show={showNotesModal}
                setShow={setShowNotesModal}
                currentPlant={currentPlant}
                setSpinner={setSpinner}
            />
            <ClonesModal 
                show={showClonesModal}
                setShow={setShowClonesModal}
                clones={clones}
                setSpinner={setSpinner}
                setPlantPhenotypes={setPlantPhenotypes}
                setPlantDescriptors={setPlantDescriptors}
                setPlantSummary={setPlantSummary}
                setShowSummaryModal={setShowModal}
            />
        </div>
        </>
    );
};

export default PlantSearch;

